import script from "./OrderItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderItemList.vue?vue&type=script&setup=true&lang=js"

import "./OrderItemList.vue?vue&type=style&index=0&id=b725adb6&lang=scss"

const __exports__ = script;

export default __exports__